// UKSEF region: everything that differs for this site. Registered in ../regionConfig.js.
export const config = {
  code: 'UKSEF',
  sourceSite: 'digirep-uksef',
  currency: 'GBP',
  supportEmail: 'hello@digitalreporting.uk',
  careEmail: 'care@digitalreporting.uk',
  moneyPrefix: '£',
  companyIdLabel: 'Issuer identifier',
  searchProviderLabel: 'Manual issuer entry',
  phonePlaceholder: '+44 7700 900000',
  signupSubtitle: 'UKSEF annual report and NSM filing support',
  primaryService: 'uksef_preparation',
  accountTypes: [
    { value: 'uksef_xhtml_conversion', label: 'XHTML Annual Report', subtitle: 'Annual report XHTML conversion', price: 250 },
    { value: 'uksef_ixbrl_tagging', label: 'XHTML + iXBRL Tagging', subtitle: 'UKSEF/ESEF-ready tagged report', price: 900 },
  ],
  optionalServices: [
    {
      id: 'uksef_nsm_filing_support',
      title: 'NSM Filing Support',
      description: 'We support filing through the National Storage Mechanism workflow',
      price: 100,
    },
  ],
  serviceCatalog: {
    uksef_preparation: { title: 'UKSEF Preparation', price: 0 },
    uksef_nsm_filing_support: { title: 'NSM Filing Support', price: 100 },
  },
  delivery: {
    standard: { label: 'Standard', shortLabel: 'Standard', hours: 'standard', surcharge: 0 },
    express: { label: 'Priority (24 hours)', shortLabel: 'Priority', hours: '24h', surcharge: 250 },
  },
};

// Hostnames that identify this region and the host used for links back to it.
export const hosts = [];
export const primaryHost = 'ixbrl.digitalreporting.uk';
